import { useCallback } from 'react';

// TODO: update to use useSearchParams when VDP is fully on app router (no more /vehicle-v1 page router version)
export default function useForceError() {
  return useCallback(() => {
    const searchParams = new URLSearchParams(
      window.location.search.replace(/^\?+/, '')
    );

    return searchParams.has('vdp-break-spinner')
      ? // prettier-ignore
        // @ts-ignore
        ({}).foo.bar
      : null;
  }, []);
}
